module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/tables"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Tables")])])]), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("ME")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/tasks"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Tasks")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/setting"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Settings")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("LOGS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/access"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Access")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/server"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-hdd-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Server")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/repos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Repos")]), _vm._v(" "), _c('small', {
    staticClass: "label pull-right bg-green"
  }, [_vm._v("AJAX")])])]), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("PAGES")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o text-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v(" Login")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/404"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-circle-o text-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v(" 404")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "treeview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Files")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-word-o"
  }), _vm._v(" Item 1\n        ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-picture-o"
  }), _vm._v(" Item 2\n        ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Item 3\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1a94f68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 1281
// module chunks = 1